import type {ConversationEvent} from '#/models/companionEvent';

/*
 * Constants.
 */

const conversationEventCustomEventKey = 'companion-conversation-event';

/*
 * API.
 */

export function dispatchConversationEventCustomEvent(event: ConversationEvent) {
  window.dispatchEvent(new CustomEvent(conversationEventCustomEventKey, {detail: event}));
}
